/**
 * Dashboard alert columns: each notification is dispatched in a column
 * according to the model it refers to (`notification.item.ref`).
 */
export const ALERT_COLUMNS = [
  {
    key: 'supervisions',
    refs: ['Supervision'],
    icon: 'HomeOutlined',
    tint: '#E3EFEC',
    ink: '#4f8479'
  },
  {
    key: 'billing',
    refs: ['Reservation', 'Customerinvoice'],
    icon: 'EuroOutlined',
    tint: '#F2F7C8',
    ink: '#6b7500'
  },
  {
    key: 'profiles',
    refs: ['Owner', 'Pensioner', 'Rating'],
    icon: 'IdcardOutlined',
    tint: '#EFEDE4',
    ink: '#706A65'
  }
];

/**
 * Whether the notification has not been consulted by the given user yet.
 * @param {Object} notification - The notification.
 * @param {string} userId - The current user id.
 * @returns {boolean} - True when the user has not consulted the notification.
 */
export const isUnreadNotification = (notification, userId) =>
  !notification.consulted?.includes(userId);

/**
 * Keeps only the notifications attached to an existing item.
 * @param {Array} notifications - All the notifications.
 * @returns {Array} - The notifications to display.
 */
export const getDisplayableNotifications = (notifications) =>
  (notifications || []).filter(
    (notification) => notification.item?.type !== null
  );
